import axios from 'axios';
import React from 'react';
import Joyride from 'react-joyride';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { descobrirContrato } from '../../actions/ContratoActions';
import { obterItensTipoFTab } from '../../actions/ItemActions';
import { enviarEmail } from '../../actions/EmailActions';
import { obterFormandosPeloContrato } from '../../actions/FormandoActions';
import { REQUEST_URL, URL_PAGAMENTO } from '../../config/urls';
import TelegramService from '../../services/TelegramService';
import {
  GaleriaProduto,
  MiniaturaProduto,
} from '../../components/GaleriaProduto';
import './styles.css';

/** Seta do acordeao de descricao. */
const IconeSetinha = ({ aberta }) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.6'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    style={{ display: 'block' }}
  >
    {aberta ? <path d='M5 15l7-7 7 7' /> : <path d='M5 9l7 7 7-7' />}
  </svg>
);

/** Carrinho de compras (icone solido, desenho classico). */
const IconeCarrinho = ({ tamanho = 16 }) => (
  <svg
    className='pf-icone-carrinho'
    width={tamanho}
    height={tamanho}
    viewBox='0 0 24 24'
    fill='currentColor'
    aria-hidden='true'
    focusable='false'
  >
    <path d='M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' />
  </svg>
);

/**
 * Marcos do cronograma que viram fase do pedido. Sao os nomes que a tabela
 * `procedimentos` do mapa de vendas usa; a comparacao e por trecho, entao as
 * variacoes de grafia (com e sem acento) ficam listadas.
 *
 * A fase muda no marco que realmente muda a situacao do produto:
 *   - liberação de bureau   -> o arquivo foi para a grafica   (Em produção)
 *   - saída da produção     -> o material saiu da grafica     (Em envio)
 *   - entrega dos convites  -> concluida, chegou ao formando  (Entregue)
 * Tudo que vem antes (briefing, publicação, revisão, aprovação, fotos e
 * personalização) ainda e preparação: fica Em andamento.
 */
const ETAPAS_PRODUCAO = [
  'liberação de bureau',
  'liberacao de bureau',
  'liberação bureau',
  'liberacao bureau',
];

const ETAPAS_ENVIO = [
  'saída da produção',
  'saida da produção',
  'saida da producao',
  'entrega dos convites',
];

/** So marca Entregue quando a etapa esta concluida, nao ao iniciar. */
const ETAPAS_ENTREGA = ['entrega dos convites'];

/** Pos vendas so existe com o convite ja na mao do formando. */
const ETAPAS_POS_ENTREGA = ['pós vendas', 'pos vendas'];

/** Ordem em que o pedido avanca: vale sempre a fase mais adiantada. */
const ORDEM_FASES = ['andamento', 'producao', 'envio', 'entregue'];

/** Rotulo e cor de cada fase. */
const FASES = {
  andamento: { rotulo: 'Em andamento', classe: 'pf-status-andamento' },
  producao: { rotulo: 'Em produção', classe: 'pf-status-producao' },
  envio: { rotulo: 'Em envio', classe: 'pf-status-envio' },
  entregue: { rotulo: 'Entregue', classe: 'pf-status-entregue' },
};

/** A etapa casa com o marco quando o nome contem um dos trechos listados. */
function ehEtapa(nome, marcos) {
  return marcos.some((marco) => nome.indexOf(marco) > -1);
}

/** Sinais do seletor de quantidade. */
const IconeSinal = ({ mais }) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='3'
    strokeLinecap='round'
    aria-hidden='true'
    style={{ display: 'block' }}
  >
    <path d='M5 12h14' />
    {mais ? <path d='M12 5v14' /> : null}
  </svg>
);

class Contrato extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pedidos: [],
      carregandoPedidos: true,
      erroPedidos: false,
      run: false,
      produtoNaGaleria: null,
      detalheAberto: null,
      quantidades: {},
      cronograma: [],
      carregandoCronograma: true,
      recompraAberta: null,
      quantidadesRecompra: {},
    };
  }

  componentWillMount() {
    if (localStorage.getItem('tutorialContrato') === null) {
      this.setState({ run: true });
      localStorage.setItem('tutorialContrato', true);
    }

    this.props
      .descobrirContrato(
        this.props.usuario.tipo,
        this.usuarioEhFormando()
          ? this.props.numeroContrato
          : this.props.usuario.id
      )
      .catch(() => {
        this.setState({ carregandoPedidos: false, erroPedidos: true });
      });
  }

  componentDidMount() {
    this.sincronizarDados();
    this.inicializarQuantidades();
  }

  componentDidUpdate() {
    this.sincronizarDados();
    this.inicializarQuantidades();
  }

  /**
   * A action do contrato nao devolve os dados carregados, entao a busca dos
   * pedidos e do catalogo espera o contrato aparecer nas props (o menu tambem
   * carrega o contrato, entao ele pode chegar antes desta tela montar).
   */
  sincronizarDados() {
    const contratoId = this.props.contrato && this.props.contrato.id;

    if (!contratoId || this.contratoSincronizado === contratoId) return;
    this.contratoSincronizado = contratoId;

    this.props.obterFormandosPeloContrato(contratoId);
    this.carregarPedidos();

    if (this.podeComprar()) {
      this.props.obterItensTipoFTab(contratoId, [
        'avulso',
        'kit',
        'itemFuturo',
      ]);
      this.carregarCronograma();
    }
  }

  /**
   * Cronograma do contrato, a mesma fonte da tela /cronograma. E dele que sai
   * o status de producao mostrado em cada compra.
   */
  carregarCronograma() {
    const numero = this.props.contrato && this.props.contrato.numero;

    if (!numero) {
      this.setState({ carregandoCronograma: false });
      return;
    }

    axios
      .get(`${REQUEST_URL}/dashboard/contrato/timeline`, {
        params: { codigo: numero },
      })
      .then((response) => {
        this.setState({
          cronograma: (response.data && response.data.procedimentos) || [],
          carregandoCronograma: false,
        });
      })
      .catch(() => {
        this.setState({ carregandoCronograma: false });
      });
  }

  /* ------------------------------------------------------------------ dados */

  usuarioEhFormando() {
    return this.props.usuario.tipo === 'formando';
  }

  podeComprar() {
    return this.usuarioEhFormando() && this.props.contrato.sistemaPagto === 1;
  }

  carregarPedidos() {
    if (!this.podeComprar()) {
      this.setState({ carregandoPedidos: false });
      return;
    }

    const tokenPagamento = sessionStorage.getItem('tokenPagamento');

    if (!tokenPagamento) {
      this.setState({ carregandoPedidos: false, erroPedidos: true });
      return;
    }

    const cabecalhos = { Authorization: 'Bearer ' + tokenPagamento };

    // As compras vem de duas origens: os pedidos da agencia e as compras da
    // Web Loja. A loja e complementar - se ela falhar, os pedidos da agencia
    // ainda aparecem -, entao o erro dela nao derruba a tela.
    const daLoja = axios
      .get(`${URL_PAGAMENTO}/formando/compras-webloja`, { headers: cabecalhos })
      .then((resposta) => (Array.isArray(resposta.data) ? resposta.data : []))
      .catch(() => []);

    Promise.all([
      axios.get(`${URL_PAGAMENTO}/formando/pedidos`, { headers: cabecalhos }),
      daLoja,
    ])
      .then(([respostaPedidos, comprasDaLoja]) => {
        const pedidos = Array.isArray(respostaPedidos.data)
          ? respostaPedidos.data
          : [];

        this.setState({
          pedidos: pedidos.concat(comprasDaLoja),
          carregandoPedidos: false,
        });
      })
      .catch((erro) => {
        this.setState({ carregandoPedidos: false, erroPedidos: true });
        new TelegramService().novo('ERROR', [
          JSON.stringify(erro),
          'Pegar os pedidos do formando - tela inicial',
          `usuarioLogado: ${sessionStorage.getItem('usuarioLogadoComissao')}`,
        ]);
      });
  }

  /** Consolida os pedidos do formando em indicadores e em uma lista de itens. */
  resumoDasCompras() {
    let valorTotal = 0,
      valorPago = 0,
      quantidadeItens = 0,
      quantidadePedidos = 0;
    const mapaItens = {};

    this.state.pedidos.forEach((pedido) => {
      if (pedido.status === 'Pedido cancelado') return;

      quantidadePedidos += 1;

      const cobranca = pedido.cobranca || {};
      valorTotal += Number(cobranca.valor) || 0;
      valorPago += Number(cobranca.valorJaPago) || 0;

      (pedido.itens || []).forEach((item) => {
        const nome = item.nome || item.produto || 'Item';
        const quantidade = Number(item.quantidade) || 0;
        const valor = Number(item.valor != null ? item.valor : item.total) || 0;

        quantidadeItens += quantidade;

        if (!mapaItens[nome]) {
          mapaItens[nome] = { nome, quantidade: 0, valor: 0 };
        }
        mapaItens[nome].quantidade += quantidade;
        mapaItens[nome].valor += valor;
      });
    });

    return {
      itens: Object.keys(mapaItens)
        .map((nome) => mapaItens[nome])
        .sort((a, b) => a.valor - b.valor),
      valorTotal,
      valorPago,
      valorPendente: Math.max(valorTotal - valorPago, 0),
      quantidadeItens,
      quantidadePedidos,
    };
  }

  /** Itens contratados (visao da comissao). */
  resumoDoContrato() {
    const itensContrato = this.props.contrato.itens || [];
    let valorTotal = 0,
      quantidadeItens = 0;

    const itens = itensContrato.map((item) => {
      const quantidade = Number(item.quantidade) || 0;
      const valor = quantidade * (Number(item.preco) || 0);

      valorTotal += valor;
      quantidadeItens += quantidade;

      return { nome: item.produto || item.nome || 'Item', quantidade, valor };
    });

    return { itens, valorTotal, quantidadeItens };
  }

  /**
   * Catalogo do formando: usa a lista de distribuiveis quando ela chega e,
   * enquanto isso, os itens que ja vem junto com o contrato. Filtra por
   * exclusao (fora brindes) para nao depender do preenchimento de categoria.
   */
  catalogoDeProdutos() {
    const distribuiveis = this.props.itensDisponiveis || [];
    const doContrato = this.props.contrato.itens || [];
    const catalogo = distribuiveis.length > 0 ? distribuiveis : doContrato;

    return catalogo.filter((item) => !this.ehBrinde(item));
  }

  /**
   * Brinde e cortesia da comissao: nao se compra, nao conta como meta e nao
   * recebe sugestao de quantidade. O cadastro marca pela observacao, e os
   * itens de brinde ainda vem com tipo 'P'.
   */
  ehBrinde(item) {
    return item.observacao === 'brinde' || item.tipo === 'P';
  }

  /**
   * Contrato com a distribuicao encerrada pela comissao: a loja fechou e
   * ninguem compra mais. E o mesmo flag que bloqueia a tela /comprar.
   */
  lojaFechada() {
    return this.props.contrato.distribuiuItens === 1;
  }

  /**
   * Produtos que o formando pode adquirir. Quem ja comprou continua na lista,
   * porque nada impede comprar mais unidades; o que muda e a sugestao, que
   * desconta o que ja foi adquirido.
   */
  produtosDisponiveis() {
    const catalogo = this.catalogoDeProdutos();
    if (catalogo.length === 0) return [];

    return catalogo
      .map((item) => ({
        id: item.id,
        nome: item.produto,
        fotos: item.fotos,
        preco:
          Number(
            item.observacao === 'itemFuturo' ? item.valorAdendo : item.preco
          ) || 0,
      }))
      .filter((item) => item.preco > 0)
      .sort((a, b) => a.preco - b.preco);
  }

  /* ------------------------------------------------- quantidade desejada  */

  /**
   * Formandos do contrato. A lista carregada e a fonte principal; enquanto
   * ela nao chega, as turmas do proprio contrato ja trazem os formandos.
   */
  totalDeFormandos() {
    const carregados = (this.props.formandos || []).filter(
      (formando) =>
        formando.contrato == null ||
        Number(formando.contrato) === Number(this.props.contrato.id)
    );

    if (carregados.length > 0) return carregados.length;

    return (this.props.contrato.turmas || []).reduce(
      (total, turma) => total + ((turma.formandos || []).length),
      0
    );
  }

  /**
   * Quantidade fechada no contrato mae para o produto: e a meta que a turma
   * inteira precisa atingir para nao haver reajuste de preco.
   */
  metaDoContrato(produto) {
    const itens = (this.props.contrato.itens || []).filter(
      (item) => !this.ehBrinde(item)
    );
    const porId = itens.filter((item) => item.id === produto.id)[0];
    const item =
      porId ||
      itens.filter(
        (item) =>
          this.chaveProduto(item.produto) === this.chaveProduto(produto.nome)
      )[0];

    return item ? Number(item.quantidade) || 0 : 0;
  }

  /**
   * Media por formando para a turma bater a quantidade minima do contrato.
   * Arredonda para cima: com o piso, a soma da turma ficaria abaixo da meta.
   */
  /**
   * Unidades desse produto que o formando ja comprou. Vem dos pedidos (API de
   * pagamento), a mesma fonte da tabela "Minhas compras".
   */
  quantidadeJaComprada(produto) {
    const chave = this.chaveProduto(produto.nome);
    let total = 0;

    this.resumoDasCompras().itens.forEach((item) => {
      if (this.chaveProduto(item.nome) === chave) total += item.quantidade;
    });

    return total;
  }

  quantidadeSugerida(produto) {
    if (this.lojaFechada()) return 0;

    const meta = this.metaDoContrato(produto);
    const formandos = this.totalDeFormandos();

    if (meta <= 0 || formandos <= 0) return 0;

    // A media e por formando, nao por compra: o que ja foi adquirido abate.
    const media = Math.ceil(meta / formandos);

    return Math.max(0, media - this.quantidadeJaComprada(produto));
  }

  quantidadeDesejada(produto) {
    const escolhida = this.state.quantidades[produto.id];

    return escolhida === undefined ? this.quantidadeSugerida(produto) : escolhida;
  }

  normalizarQuantidade(valor) {
    return Math.max(0, Math.floor(Number(valor) || 0));
  }

  alterarQuantidade(produto, valor) {
    this.setState({
      quantidades: {
        ...this.state.quantidades,
        [produto.id]: this.normalizarQuantidade(valor),
      },
    });
  }

  /**
   * Preenche as quantidades sugeridas assim que catalogo, pedidos e formandos
   * chegam. Roda uma vez so: depois disso vale o que o formando digitou.
   */
  inicializarQuantidades() {
    if (this.quantidadesIniciadas || this.state.carregandoPedidos) return;
    if (this.lojaFechada()) return;

    const produtos = this.produtosDisponiveis();

    if (produtos.length === 0 || this.totalDeFormandos() === 0) return;

    this.quantidadesIniciadas = true;

    const quantidades = {};

    produtos.forEach((produto) => {
      quantidades[produto.id] = this.quantidadeSugerida(produto);
    });

    this.setState({ quantidades });
  }

  /** Total geral da adesao: soma das linhas com quantidade escolhida. */
  resumoDaAdesao() {
    let quantidadeItens = 0,
      valorTotal = 0;

    this.produtosDisponiveis().forEach((produto) => {
      const quantidade = this.quantidadeDesejada(produto);

      quantidadeItens += quantidade;
      valorTotal += quantidade * produto.preco;
    });

    return { quantidadeItens, valorTotal };
  }

  /** Quantidades marcadas na tabela de adesao, prontas para o pagamento. */
  quantidadesDaAdesao() {
    const quantidades = {};

    this.produtosDisponiveis().forEach((produto) => {
      const quantidade = this.quantidadeDesejada(produto);

      if (quantidade > 0) quantidades[produto.id] = quantidade;
    });

    return quantidades;
  }

  /**
   * Leva as quantidades escolhidas para a tela de compra, que ja concentra as
   * regras de kit obrigatorio, termo e valor minimo, e abre o pagamento la.
   */
  irParaPagamento(quantidades) {
    this.props.history.push('/comprar', {
      quantidades,
      irParaPagamento: true,
    });
  }

  /* ------------------------------------------------------ adquirir mais  */

  /**
   * Produto do catalogo correspondente a uma compra ja feita. Sem ele (item
   * que saiu do catalogo ou sem preco) a recompra fica indisponivel.
   */
  produtoParaRecompra(nome) {
    const doCatalogo = this.produtoDoCatalogo(nome);

    if (!doCatalogo) return null;

    const preco =
      Number(
        doCatalogo.observacao === 'itemFuturo'
          ? doCatalogo.valorAdendo
          : doCatalogo.preco
      ) || 0;

    if (preco <= 0) return null;

    return { id: doCatalogo.id, nome, preco };
  }

  quantidadeDaRecompra(chave) {
    const escolhida = this.state.quantidadesRecompra[chave];

    return escolhida === undefined ? 1 : escolhida;
  }

  alterarQuantidadeRecompra(chave, valor) {
    this.setState({
      quantidadesRecompra: {
        ...this.state.quantidadesRecompra,
        [chave]: this.normalizarQuantidade(valor),
      },
    });
  }

  /** Abre (ou fecha) o seletor de quantidade na linha da compra. */
  alternarRecompra(chave) {
    this.setState({
      recompraAberta: this.state.recompraAberta === chave ? null : chave,
    });
  }

  /* ------------------------------------------- status pelo cronograma  */

  etapaConcluida(procedimento) {
    const status = (procedimento.Status || '').toString().toLowerCase();

    return status === 'concluido' || status === 'concluído';
  }

  /** Etapa que ja saiu do papel: em execucao ou concluida. */
  etapaComecou(procedimento) {
    const status = (procedimento.Status || '').toString().toLowerCase();

    return (
      this.etapaConcluida(procedimento) ||
      status === 'execução' ||
      status === 'execucao'
    );
  }

  /**
   * Fase do pedido segundo o cronograma do contrato. Vale a etapa mais
   * avancada ja alcancada. Enquanto nenhum marco e atingido (ou se o
   * cronograma nao carrega) fica em andamento, o estado inicial do contrato.
   */
  faseDoCronograma() {
    let fase = 'andamento';

    const avancar = (nova) => {
      if (ORDEM_FASES.indexOf(nova) > ORDEM_FASES.indexOf(fase)) fase = nova;
    };

    (this.state.cronograma || []).forEach((procedimento) => {
      const nome = (procedimento.procedimento || '').toString().toLowerCase();
      const comecou = this.etapaComecou(procedimento);

      if (!comecou) return;

      if (ehEtapa(nome, ETAPAS_PRODUCAO)) avancar('producao');
      if (ehEtapa(nome, ETAPAS_ENVIO)) avancar('envio');

      // A entrega em execucao ainda e transporte; so a conclusao entrega.
      if (
        ehEtapa(nome, ETAPAS_POS_ENTREGA) ||
        (ehEtapa(nome, ETAPAS_ENTREGA) && this.etapaConcluida(procedimento))
      ) {
        avancar('entregue');
      }
    });

    return fase;
  }

  /** Fotos cadastradas para um produto, procurando no catalogo pelo nome. */
  produtoDoCatalogo(nome) {
    const chave = this.chaveProduto(nome);

    return this.catalogoDeProdutos().filter(
      (item) => this.chaveProduto(item.produto) === chave
    )[0];
  }

  /**
   * Quebra a descricao em topicos. No cadastro, os blocos vem separados por
   * "," (quando o kit junta varios produtos) e por "/" (partes do mesmo
   * produto); dentro de cada bloco, "+" lista os acabamentos.
   */
  topicosDaDescricao(texto) {
    if (!texto) return [];

    return String(texto)
      .replace(/[;,\s]+$/, '')
      .split(/[,/]/)
      .map((bloco) => bloco.trim())
      .filter((bloco) => bloco.length > 0)
      .map((bloco) => {
        const partes = bloco
          .split('+')
          .map((parte) => parte.trim())
          .filter((parte) => parte.length > 0);

        return { titulo: partes[0], detalhes: partes.slice(1) };
      });
  }

  /** Composicao do kit ("1 Convite;2 Encartes" -> lista). */
  topicosDaComposicao(texto) {
    if (!texto) return [];

    return String(texto)
      .replace(/[;\s]+$/, '')
      .split(';')
      .map((parte) => parte.trim())
      .filter((parte) => parte.length > 0);
  }

  detalhesDoProduto(nome) {
    const doCatalogo = this.produtoDoCatalogo(nome) || {};

    return {
      composicao: this.topicosDaComposicao(doCatalogo.itens),
      descricao: this.topicosDaDescricao(doCatalogo.descricao),
    };
  }

  alternarDetalhe(chave) {
    this.setState({
      detalheAberto: this.state.detalheAberto === chave ? null : chave,
    });
  }

  renderBotaoDetalhe(chave) {
    const aberto = this.state.detalheAberto === chave;

    return (
      <button
        type='button'
        className={aberto ? 'pf-btn-detalhe aberto' : 'pf-btn-detalhe'}
        onClick={() => this.alternarDetalhe(chave)}
        title={aberto ? 'Ocultar descrição' : 'Ver descrição'}
      >
        <IconeSetinha aberta={aberto} />
      </button>
    );
  }

  renderDetalhes(nome) {
    const { composicao, descricao } = this.detalhesDoProduto(nome);
    const tipo = this.categoriaDoProduto(nome);

    return (
      <div className='pf-detalhes'>
        {tipo !== '-' ? (
          <div className='pf-detalhes-bloco'>
            <div className='pf-detalhes-titulo'>Tipo</div>
            <div className='pf-detalhes-texto'>{tipo}</div>
          </div>
        ) : null}

        {composicao.length > 0 ? (
          <div className='pf-detalhes-bloco'>
            <div className='pf-detalhes-titulo'>O que vem no produto</div>
            <ul className='pf-topicos'>
              {composicao.map((parte, indice) => (
                <li key={indice}>{parte}</li>
              ))}
            </ul>
          </div>
        ) : null}

        {composicao.length === 0 && descricao.length === 0 ? (
          <div className='pf-detalhes-vazio'>
            Sem descrição cadastrada para este produto.
          </div>
        ) : null}

        {descricao.length > 0 ? (
          <div className='pf-detalhes-bloco'>
            <div className='pf-detalhes-titulo'>Especificações</div>
            <ul className='pf-topicos'>
              {descricao.map((topico, indice) => (
                <li key={indice}>
                  {topico.titulo}
                  {topico.detalhes.length > 0 ? (
                    <ul>
                      {topico.detalhes.map((detalhe, posicao) => (
                        <li key={posicao}>{detalhe}</li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    );
  }

  /** Tipo do produto: a categoria cadastrada no item. */
  categoriaDoProduto(nome) {
    const doCatalogo = this.produtoDoCatalogo(nome) || {};
    const categoria = (doCatalogo.categoria || '').toString().trim();

    return categoria.length > 0 ? categoria : '-';
  }

  abrirGaleria(nome) {
    const doCatalogo = this.produtoDoCatalogo(nome);

    this.setState({
      produtoNaGaleria: {
        nome,
        fotos: doCatalogo ? doCatalogo.fotos : null,
      },
    });
  }

  fecharGaleria() {
    this.setState({ produtoNaGaleria: null });
  }

  chaveProduto(nome) {
    return (nome || '').toString().trim().toLowerCase();
  }

  /* ---------------------------------------------------------------- helpers */

  formatarMoeda(valor) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(Number(valor) || 0);
  }

  /** R$ alinhado a esquerda e o numero a direita, para as linhas baterem. */
  renderValor(valor) {
    const numero = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(valor) || 0);

    return (
      <span className='pf-moeda'>
        <span className='pf-moeda-simbolo'>R$</span>
        <span className='pf-moeda-numero'>{numero}</span>
      </span>
    );
  }

  formatarData(data) {
    if (!data) return '--';
    const convertida = new Date(data);
    if (isNaN(convertida.getTime())) return '--';
    return convertida.toLocaleDateString('pt-BR');
  }

  primeiroNome() {
    const nome = (this.props.usuario && this.props.usuario.nome) || '';
    if (!nome) return 'Formando(a)';

    const base = nome.indexOf('@') > -1 ? nome.split('@')[0] : nome;
    const primeiro = base.trim().split(' ')[0] || base;

    return primeiro.charAt(0).toUpperCase() + primeiro.slice(1).toLowerCase();
  }

  passosTutorial() {
    const passos = [
      {
        content: (
          <div>
            <h3>Bem-vindo(a) ao seu portal!</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Aqui você acompanha as informações do seu contrato de formatura.
            </span>
          </div>
        ),
        placement: 'center',
        target: '#divContent',
        disableBeacon: true,
      },
      {
        content: (
          <div>
            <h3>Informações do contrato</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Número do contrato, gestor(a) responsável e data de início ficam
              sempre à mão.
            </span>
          </div>
        ),
        placement: 'bottom',
        target: '#dadosGerais',
      },
    ];

    if (this.podeComprar()) {
      passos.push({
        content: (
          <div>
            <h3>Suas compras</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Veja os itens que você já adquiriu e compre mais quando quiser.
            </span>
          </div>
        ),
        placement: 'top',
        target: '#painelCompras',
      });
    }

    return passos;
  }

  /* ---------------------------------------------------------------- blocos  */

  renderCabecalho() {
    const { contrato } = this.props;
    const gestor = (contrato.dono && contrato.dono.nome) || 'Não definido';

    return (
      <section className='pf-head' id='divContent'>
        <div className='pf-head-main'>
          <span className='pf-eyebrow'>Portal do formando</span>

          <h1 className='pf-hello'>Olá, {this.primeiroNome()}!</h1>

          <p className='pf-lead'>
            Seja bem-vindo(a) e obrigado por escolher a{' '}
            <strong>Alpha Convites</strong>. Este é o seu portal exclusivo.
          </p>
        </div>

        <div className='pf-meta' id='dadosGerais'>
          <div className='pf-meta-item'>
            <div className='pf-meta-label'>Contrato</div>
            <div className='pf-meta-value is-strong'>
              {contrato.numero || '--'}
            </div>
          </div>

          <div className='pf-meta-item'>
            <div className='pf-meta-label'>Gestor(a)</div>
            <div className='pf-meta-value'>{gestor}</div>
          </div>

          <div className='pf-meta-item'>
            <div className='pf-meta-label'>Data de início</div>
            <div className='pf-meta-value'>
              {this.formatarData(contrato.dataInicio)}
            </div>
          </div>

          <div className='pf-meta-item'>
            <div className='pf-meta-label'>E-mail principal</div>
            <div className='pf-meta-value'>
              {contrato.emailComissao || '--'}
            </div>
          </div>
        </div>
      </section>
    );
  }

  renderCarregando() {
    return (
      <div className='pf-skeleton pf-skeleton-card' />
    );
  }

  renderTabelaItens(resumo, titulo, rotuloTotal) {
    const { itens } = resumo;

    return (
      <div className='pf-card'>
        <div className='pf-card-head'>
          <h3 className='pf-card-title'>{titulo}</h3>
          <span className='pf-card-note'>
            {itens.length === 1 ? '1 produto' : `${itens.length} produtos`}
          </span>
        </div>

        <div className='pf-tr pf-thead'>
          <div>Item</div>
          <div className='pf-cell-categoria'>Tipo</div>
          <div className='pf-cell-qty'>Quantidade</div>
          <div className='pf-cell-value'>Valor</div>
        </div>

        <div className='pf-tbody'>
          {itens.map((item, indice) => {
            const chave = `contratado-${item.nome}-${indice}`;

            return (
              <div className='pf-linha' key={chave}>
                <div className='pf-tr'>
                  <div className='pf-item'>
                    <MiniaturaProduto
                      produto={{
                        nome: item.nome,
                        fotos: (this.produtoDoCatalogo(item.nome) || {}).fotos,
                      }}
                      tamanho={58}
                      onClick={() => this.abrirGaleria(item.nome)}
                    />
                    <div className='pf-item-label'>{item.nome}</div>
                    {this.renderBotaoDetalhe(chave)}
                  </div>

                  <div className='pf-cell-categoria'>
                    <div className='pf-cell-label'>Tipo</div>
                    {this.categoriaDoProduto(item.nome)}
                  </div>

                  <div className='pf-cell-qty'>
                    <div className='pf-cell-label'>Quantidade</div>
                    {item.quantidade}
                  </div>

                  <div className='pf-cell-value'>
                    <div className='pf-cell-label'>Valor</div>
                    {this.renderValor(item.valor)}
                  </div>
                </div>

                {this.state.detalheAberto === chave
                  ? this.renderDetalhes(item.nome)
                  : null}
              </div>
            );
          })}
        </div>

        <div className='pf-tr pf-tfoot'>
          <span className='pf-tfoot-label'>{rotuloTotal}</span>
          <span />
          <span className='pf-tfoot-qty'>{resumo.quantidadeItens}</span>
          <span className='pf-tfoot-value'>
            {this.renderValor(resumo.valorTotal)}
          </span>
        </div>
      </div>
    );
  }

  /* -------------------------------------------------- tabela de compras  */

  /** Etiqueta da fase do pedido, vinda do cronograma do contrato. */
  renderStatusDaCompra() {
    if (this.state.carregandoCronograma) {
      return <span className='pf-status pf-status-carregando'>Carregando</span>;
    }

    const fase = FASES[this.faseDoCronograma()];

    return <span className={`pf-status ${fase.classe}`}>{fase.rotulo}</span>;
  }

  /**
   * Coluna "Adquirir mais": o botao abre o seletor de quantidade na propria
   * linha e o Pagar leva so aquele item para o pagamento.
   */
  renderRecompra(item, chave) {
    if (this.lojaFechada()) {
      return (
        <div className='pf-cell-action'>
          <div className='pf-cell-label'>Adquirir mais</div>
          <span className='pf-sem-recompra'>Compras encerradas</span>
        </div>
      );
    }

    const produto = this.produtoParaRecompra(item.nome);

    if (!produto) {
      return (
        <div className='pf-cell-action'>
          <div className='pf-cell-label'>Adquirir mais</div>
          <span className='pf-sem-recompra'>Indisponível</span>
        </div>
      );
    }

    if (this.state.recompraAberta !== chave) {
      return (
        <div className='pf-cell-action'>
          <div className='pf-cell-label'>Adquirir mais</div>
          <button
            type='button'
            className='pf-btn-row'
            onClick={() => this.alternarRecompra(chave)}
          >
            <IconeSinal mais={true} /> Adquirir mais
          </button>
        </div>
      );
    }

    const quantidade = this.quantidadeDaRecompra(chave);

    return (
      <div className='pf-cell-action pf-cell-recompra'>
        <div className='pf-cell-label'>Adquirir mais</div>

        <div className='pf-recompra-linha'>
          {this.renderStepper({
            quantidade,
            rotulo: `Quantidade de ${produto.nome}`,
            aoMudar: (valor) => this.alterarQuantidadeRecompra(chave, valor),
          })}

          <button
            type='button'
            className='pf-btn-row pf-btn-row-primario'
            onClick={() => this.irParaPagamento({ [produto.id]: quantidade })}
            disabled={quantidade <= 0}
            title={`${quantidade} x ${this.formatarMoeda(produto.preco)}`}
          >
            <IconeCarrinho tamanho={14} /> Pagar
          </button>
        </div>

        <button
          type='button'
          className='pf-btn-cancelar'
          onClick={() => this.alternarRecompra(chave)}
        >
          Cancelar
        </button>
      </div>
    );
  }

  renderLinhaCompra(item) {
    const chave = `adquirido-${item.nome}`;

    return (
      <div className='pf-linha' key={chave}>
        <div className='pf-tr pf-tr-compra'>
          <div className='pf-item'>
            <MiniaturaProduto
              produto={{
                nome: item.nome,
                fotos: (this.produtoDoCatalogo(item.nome) || {}).fotos,
              }}
              tamanho={58}
              onClick={() => this.abrirGaleria(item.nome)}
            />

            <div className='pf-item-label'>{item.nome}</div>
            {this.renderBotaoDetalhe(chave)}
          </div>

          <div className='pf-cell-qty'>
            <div className='pf-cell-label'>Qtd. comprada</div>
            {item.quantidade}
          </div>

          <div className='pf-cell-status'>
            <div className='pf-cell-label'>Status</div>
            {this.renderStatusDaCompra()}
          </div>

          {this.renderRecompra(item, chave)}
        </div>

        {this.state.detalheAberto === chave
          ? this.renderDetalhes(item.nome)
          : null}
      </div>
    );
  }

  renderTabelaCompras(resumo) {
    const { itens } = resumo;

    return (
      <div className='pf-card'>
        <div className='pf-card-head'>
          <h3 className='pf-card-title'>Itens adquiridos</h3>
          <span className='pf-card-note'>
            Total investido: {this.formatarMoeda(resumo.valorTotal)}
          </span>
        </div>

        <div className='pf-tr pf-tr-compra pf-thead'>
          <div>Produto</div>
          <div className='pf-cell-qty'>Qtd. comprada</div>
          <div className='pf-cell-status'>Status</div>
          <div className='pf-cell-action'>Adquirir mais</div>
        </div>

        <div className='pf-tbody'>
          {itens.map((item) => this.renderLinhaCompra(item))}
        </div>
      </div>
    );
  }

  renderEstadoVazio() {
    return (
      <div className='pf-vazio'>
        <p className='pf-vazio-texto'>
          Você ainda não realizou nenhuma compra. Escolha um dos produtos
          acima, defina a quantidade e finalize o pedido com pagamento por Pix,
          cartão ou boleto.
        </p>

        <Link to='/comprar' className='pf-btn pf-btn-primary'>
          <IconeCarrinho tamanho={16} /> Começar minha primeira compra
        </Link>
      </div>
    );
  }

  /** Seletor de quantidade com os botoes de + e -. */
  renderStepper({ quantidade, aoMudar, rotulo }) {
    return (
      <div className='pf-stepper'>
        <button
          type='button'
          className='pf-stepper-btn'
          onClick={() => aoMudar(quantidade - 1)}
          disabled={quantidade <= 0}
          title='Diminuir'
        >
          <IconeSinal mais={false} />
        </button>

        <input
          type='number'
          min='0'
          className='pf-stepper-input'
          value={quantidade}
          onChange={(evento) => aoMudar(evento.target.value)}
          aria-label={rotulo}
        />

        <button
          type='button'
          className='pf-stepper-btn'
          onClick={() => aoMudar(quantidade + 1)}
          title='Aumentar'
        >
          <IconeSinal mais={true} />
        </button>
      </div>
    );
  }

  /**
   * Quantidade desejada na adesao. A nota abaixo mostra de onde saiu o numero:
   * a media por formando para a turma bater o contrato.
   */
  renderSeletorQuantidade(produto) {
    const sugestao = this.quantidadeSugerida(produto);
    const jaComprada = this.quantidadeJaComprada(produto);
    const meta = this.metaDoContrato(produto);

    return (
      <div className='pf-cell-qtd'>
        <div className='pf-cell-label'>Quantidade desejada</div>

        {this.renderStepper({
          quantidade: this.quantidadeDesejada(produto),
          rotulo: `Quantidade de ${produto.nome}`,
          aoMudar: (valor) => this.alterarQuantidade(produto, valor),
        })}

        {sugestao > 0 ? (
          <div
            className='pf-stepper-nota'
            title={`A turma precisa de ${meta} unidades para fechar o contrato.`}
          >
            Sugerido: {sugestao} un.
          </div>
        ) : jaComprada > 0 ? (
          <div
            className='pf-stepper-nota'
            title={`Você já adquiriu ${jaComprada} unidades deste produto.`}
          >
            Sua meta já foi atingida
          </div>
        ) : null}
      </div>
    );
  }

  /** A comissao fechou a distribuicao: nao ha mais o que adquirir. */
  renderComprasEncerradas() {
    return (
      <section className='pf-section'>
        <div className='pf-section-head'>
          <div className='pf-section-headings'>
            <h2 className='pf-section-title'>
              Produtos contratados pela comissão
            </h2>
            <p className='pf-section-sub'>
              As compras deste contrato já foram encerradas.
            </p>
          </div>
        </div>

        <div className='pf-note'>
          <ExclamationCircleOutlined />
          <span>
            A compra dos produtos foi finalizada pela comissão, então não é
            mais possível adquirir novas unidades. Fale com a sua comissão de
            formatura se precisar de alguma informação.
          </span>
        </div>
      </section>
    );
  }

  renderLinhaOferta(produto) {
    const chave = `disponivel-${produto.id}`;
    const quantidade = this.quantidadeDesejada(produto);

    return (
      <div className='pf-linha' key={chave}>
        <div className='pf-tr pf-tr-oferta'>
          <div className='pf-item'>
            <MiniaturaProduto
              produto={{ nome: produto.nome, fotos: produto.fotos }}
              tamanho={58}
              onClick={() => this.abrirGaleria(produto.nome)}
            />

            <div className='pf-item-label'>{produto.nome}</div>
            {this.renderBotaoDetalhe(chave)}
          </div>

          {this.renderSeletorQuantidade(produto)}

          <div className='pf-cell-value pf-cell-unitario'>
            <div className='pf-cell-label'>Valor unit.</div>
            {this.renderValor(produto.preco)}
          </div>

          <div className='pf-cell-value'>
            <div className='pf-cell-label'>Valor total</div>
            {this.renderValor(quantidade * produto.preco)}
          </div>
        </div>

        {this.state.detalheAberto === chave
          ? this.renderDetalhes(produto.nome)
          : null}
      </div>
    );
  }

  renderOfertas() {
    if (this.state.carregandoPedidos) return null;

    if (this.lojaFechada()) return this.renderComprasEncerradas();

    const produtos = this.produtosDisponiveis();

    if (produtos.length === 0) return null;

    const resumo = this.resumoDaAdesao();

    return (
      <section className='pf-section'>
        <div className='pf-section-head'>
          <div className='pf-section-headings'>
            <h2 className='pf-section-title'>
              Produtos contratados pela comissão
            </h2>
            <p className='pf-section-sub'>
              Produtos liberados para a sua turma. Escolha a quantidade de cada
              um e finalize o pedido.
            </p>
          </div>

          <Link to='/comprar' className='pf-link'>
            Ver todos os produtos
          </Link>
        </div>

        <div className='pf-card pf-card-destaque'>
          <div className='pf-card-head'>
            <h3 className='pf-card-title'>Disponíveis para adesão</h3>
            <span className='pf-card-note'>Valores por unidade</span>
          </div>

          <div className='pf-tr pf-tr-oferta pf-thead'>
            <div>Produto</div>
            <div className='pf-cell-qtd'>Quantidade desejada</div>
            <div className='pf-cell-value'>Valor unit.</div>
            <div className='pf-cell-value'>Valor total</div>
          </div>

          <div className='pf-tbody'>
            {produtos.map((produto) => this.renderLinhaOferta(produto))}
          </div>

          <div className='pf-adesao-foot'>
            <span className='pf-adesao-total-label'>Total geral</span>

            <span className='pf-adesao-total-valor'>
              {this.renderValor(resumo.valorTotal)}
            </span>

            <button
              type='button'
              className='pf-btn-row pf-btn-row-primario'
              onClick={() => this.irParaPagamento(this.quantidadesDaAdesao())}
              disabled={resumo.valorTotal <= 0}
            >
              <IconeCarrinho tamanho={14} /> Pagar
            </button>
          </div>
        </div>
      </section>
    );
  }

  renderPainelCompras() {
    const { carregandoPedidos, erroPedidos } = this.state;
    const resumo = this.resumoDasCompras();
    const temCompras = resumo.itens.length > 0;

    return (
      <section className='pf-section' id='painelCompras'>
        <div className='pf-section-head'>
          <div className='pf-section-headings'>
            <h2 className='pf-section-title'>
              {temCompras ? 'Minhas compras feitas' : 'Minhas compras'}
            </h2>
            <p className='pf-section-sub'>
              {temCompras
                ? 'O status acompanha o cronograma do contrato. Você pode adquirir mais unidades a qualquer momento.'
                : 'Escolha os produtos liberados para a sua turma e finalize o pedido.'}
            </p>
          </div>
        </div>

        {carregandoPedidos ? (
          this.renderCarregando()
        ) : erroPedidos ? (
          <div className='pf-note'>
            <ExclamationCircleOutlined />
            <span>
              Não foi possível carregar as suas compras agora. Atualize a página
              em alguns instantes ou acesse <strong>Meus pedidos</strong> para
              conferir o seu histórico.
            </span>
          </div>
        ) : temCompras ? (
          this.renderTabelaCompras(resumo)
        ) : (
          this.renderEstadoVazio()
        )}
      </section>
    );
  }

  /** Formando de contrato sem venda avulsa: nao ha compras a exibir. */
  renderPainelSemVenda() {
    const gestor =
      (this.props.contrato.dono && this.props.contrato.dono.nome) || null;

    return (
      <section className='pf-section' id='painelCompras'>
        <div className='pf-section-head'>
          <div className='pf-section-headings'>
            <h2 className='pf-section-title'>Minhas compras</h2>
            <p className='pf-section-sub'>
              Neste contrato os itens não são vendidos individualmente no
              portal.
            </p>
          </div>
        </div>

        <p className='pf-vazio-texto'>
          Os pedidos da sua turma são feitos pela comissão de formatura
          {gestor ? ` ou pelo(a) gestor(a) ${gestor}` : ''}. Você continua
          acompanhando o convite e a personalização por aqui.
        </p>
      </section>
    );
  }

  renderPainelContrato() {
    const resumo = this.resumoDoContrato();

    if (resumo.itens.length === 0) return null;

    return (
      <section className='pf-section' id='painelCompras'>
        <div className='pf-section-head'>
          <div className='pf-section-headings'>
            <h2 className='pf-section-title'>Itens contratados</h2>
            <p className='pf-section-sub'>
              Produtos previstos no contrato da sua turma.
            </p>
          </div>
        </div>

        {this.renderTabelaItens(
          resumo,
          'Itens do contrato',
          'Valor total do contrato'
        )}
      </section>
    );
  }

  /** Banner da loja, exibido no fim da tela para quem ja comprou. Desativado por enquanto. */
  renderBanner() {
    return (
      <a
        className='pf-banner'
        href='https://alphapress.com.br/'
        target='_blank'
        rel='noopener noreferrer'
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/banner-web-loja.png`}
          alt='Conheça a loja da Alpha'
        />
      </a>
    );
  }

  /** A tabela de adesao vem primeiro; o que ja foi comprado fica abaixo. */
  renderConteudoDoFormando() {
    return (
      <React.Fragment>
        {this.renderOfertas()}
        {this.renderPainelCompras()}
        {/* Banner da loja temporariamente desativado */}
        {/* {this.renderBanner()} */}
      </React.Fragment>
    );
  }

  render() {
    if (this.props.contrato.status === 'deletado') {
      return <Redirect to='/deletado' />;
    }

    return (
      <div className='pf-home'>
        {this.renderCabecalho()}

        {this.podeComprar()
          ? this.renderConteudoDoFormando()
          : this.usuarioEhFormando()
          ? this.renderPainelSemVenda()
          : this.renderPainelContrato()}

        <GaleriaProduto
          produto={this.state.produtoNaGaleria}
          onFechar={this.fecharGaleria.bind(this)}
        />

        <Joyride
          steps={this.passosTutorial()}
          continuous={true}
          run={this.state.run}
          scrollToFirstStep={true}
          showProgress={true}
          showSkipButton={true}
          locale={{
            back: 'Voltar',
            close: 'Fechar',
            last: 'Entendi',
            next: 'Próximo',
            skip: 'Pular',
          }}
          styles={{
            options: {
              primaryColor: '#0078d4',
              zIndex: 10000,
            },
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    contrato: state.contrato.especifico,
    formandos: state.formando.todos,
    numeroContrato: state.usuario.numeroContrato,
    itensDisponiveis: state.item.todosDistribuiveis,
  };
};

export default connect(mapStateToProps, {
  enviarEmail,
  descobrirContrato,
  obterFormandosPeloContrato,
  obterItensTipoFTab,
})(Contrato);
